import { render, staticRenderFns } from "./downgrade.vue?vue&type=template&id=7fc66580"
import script from "./downgrade.vue?vue&type=script&lang=js"
export * from "./downgrade.vue?vue&type=script&lang=js"
import style0 from "./downgrade.vue?vue&type=style&index=0&id=7fc66580&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports